import type { SVGProps } from 'react'

interface AvailableCallIconProps extends SVGProps<SVGSVGElement> {
  dataQaId?: string
  success?: boolean
}

const SvgTickUser: React.FC<AvailableCallIconProps> = ({
  success = false,
  dataQaId = '',
  ...props
}) => (
  <svg
    width="45"
    height="37"
    viewBox="0 0 38 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-qa-id={dataQaId || ''}
    {...props}
  >
    <rect
      y="0.5"
      width="38"
      height="36"
      rx="18"
      fill={!success ? '#007CF0' : '#66AF57'}
    />
    <path
      d="M27 13L16 24L11 19"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgTickUser
